import classNames from 'classnames';
import React, { useMemo } from 'react';
import { getMicroLearningThemeVars } from './microLearningThemeHelpers';
import { getThemeColor } from 'store/settings';
import styles from 'styles/Unit.module.scss';
import { useSelector } from 'react-redux';
import { stripHtml } from 'helpers';
import { ThunderboltOutlined } from '@ant-design/icons';

function microLearningContentAsText(raw) {
  if (raw == null) return '';
  const s = typeof raw === 'string' ? raw : String(raw);
  return stripHtml(s).trim();
}

const MicroLearningView = ({ microLearningContent, children }) => {
  const themeColor = useSelector(getThemeColor);
  const microLearningThemeVars = useMemo(
    () => getMicroLearningThemeVars(themeColor),
    [themeColor],
  );
  return (
    <div
      className={classNames(
        'adaptive-submit-outcome px-1 w-100',
        styles.microLearningSection,
        styles.microLearningThemeRoot,
      )}
      style={{ ...microLearningThemeVars }}
    >
      <div className={styles.microLearningHeader}>
        <ThunderboltOutlined className={styles.microLearningIcon} aria-hidden />
        <span className={styles.microLearningTitle}>Micro learning</span>
        <span className={styles.microLearningBadge}>AI</span>
      </div>
      <div className={styles.microLearningGlow}>
        <div className={styles.microLearningInner}>
          <p className={`mb-0 ${styles.microLearningPlainText}`}>
            {microLearningContentAsText(microLearningContent)}
          </p>
        </div>
      </div>
      {children}
    </div>
  );
};

export default MicroLearningView;
